export default __webpack_public_path__ + "static/media/15.14533d2c.jpg";